<template>
    <v-row>
        <v-dialog @keydown.enter="recoverPassword()" @keydown.esc="close()" persistent v-model="dialog" height="90%" max-width="350px" max-height="500px">
            <v-card>
                <v-card-title> Excluir conta </v-card-title>

                <v-card-subtitle> <span> Atenção! </span> Tem certeza que deseja excluir o seu cadastro? <br /> Todo o seu histórico será perdido. <br /> </v-card-subtitle>

                <v-card-text>
                    <v-row class="w-100">
                        <v-col xs="12" sm="12" md="12" lg="12" class="no-pd-l no-pd-r no-pd-b">
                             <v-text-field
                                placeholder=" "
                                label=" Digite: '  EXCLUIR CONTA ' "
                                color="var(--cor--preta)"
                                class="no-mg-t"
                                v-model="deleteInput"
                                clearable
                                autofocus
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="flex-row-end">
                    <v-btn class="text-none" text color="var(--cor--cinzaApp)" @click="close()" :disabled="deleteBtnLoading"> Fechar </v-btn>
                    <v-btn class="text-none" text color="#AC50FF" @click="submitDeleteInput()" :loading="deleteBtnLoading"> Excluir </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
//Store
import { mapGetters, mapActions } from "vuex";

//Services
import { deleteCompanyContactByCurrentContactIdAndCompanyId } from "./service/delete-account.service";

export default {
    name: 'deleteAccountModal',
    props: {
        dialog: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        ...mapGetters(
            'authenticateStore', {
                currentCompany: 'get_currentCompany'
            }
        )
    },
    data: () => ({
        deleteInput: null,
        deleteBtnLoading: false
    }),
    methods: {
        ...mapActions('authenticateStore',['LOGOUT']),
        confirmDeleteText() {
            if( this.deleteInput == 'EXCLUIR CONTA' ) return true
            
            return false
        },
        submitDeleteInput() {
            this.disableCloseBtn = true
            
            if( this.confirmDeleteText() ) {
                this.deleteBtnLoading = true
                deleteCompanyContactByCurrentContactIdAndCompanyId( this.currentCompany.id )
                    .then( () => {
                            this.$toasted.show('Conta excluída com sucesso!', { type: 'success' } )
                            setTimeout(() => {
                                this.LOGOUT()
                            }, 1000);
                        }
                    )
                    .catch( error => {
                            this.disableCloseBtn = false
                            this.deleteBtnLoading = false

                            if(error != null) {
                                this.$toasted.show(error.message, { type: 'error' } )
                            }
                        }
                    )

            } else this.$toasted.show('É necessário digitar: " EXCLUIR CONTA " ', { type: 'info' } )
        },
        close(){
            if( !this.deleteBtnLoading ) {
                this.$emit("closeDeleteAccountModal", false);
            }
        }
    }
}
</script>

<style>

</style>